/**
 * uploadToS3
 *
 * This function does two Ajax call:
 * The first one is a GET request against a pre sign endpoint, this endpoint returns all the data needed to upload the file onto Amazon S3.
 * The information returned by the endpoint includes:
 *   - The Key, ACL, Policy and credentials needed to do the upload.
 *   - The method that needs to be used (POST).
 *   - The URL that needs to be used.
 * The second Ajax call uploads the file after appending the necessary fields into a FormData object.
 * Be aware that the response from Amazon S3 is an XML.
 *
 * @param {String} presignedPath
 * @param {File} file
 * @param {Function} resolveCallback
 * @param {Function} rejectCallback
 */
export function uploadToS3(presignedPath, file, resolveCallback, rejectCallback) {
  return $.ajax({
    url: presignedPath,
    type: 'GET',
    data: { filename: file.name, type: file.type },
    dataType: 'json',
  }).then(
    (presignedUrlResponse) => {
      const formData = new FormData();

      for (const key in presignedUrlResponse.fields) {
        formData.append(key, presignedUrlResponse.fields[key]);
      }
      formData.append('file', file);

      return $.ajax({
        url: presignedUrlResponse.url,
        type: presignedUrlResponse.method,
        dataType: 'xml',
        paramName: 'file',
        contentType: false,
        processData: false,
        data: formData,
      })
        .success(function () {
          resolveCallback(presignedUrlResponse);
        })
        .fail(function (jqXHR, textStatus) {
          rejectCallback(jqXHR, textStatus);
        });
    },
    (error) => {
      rejectCallback(error);
    },
  );
}
